module.exports = __webpack_public_path__ + "static/media/isl.c8ee2470.jpg";